export default __webpack_public_path__ + "static/media/FourPartIllustration.793d11d6.png";